import React from 'react';

import CardPlanMain from './CardPlanMain';
import { QuestionsSection } from './QuestionsSection';
import { PriceStickyBar } from './PriceStickyBar';

import './QuoteContent.css';

const QuoteContent = () => (
  <div className="Quote-content">
    <CardPlanMain />

    <PriceStickyBar />

    <QuestionsSection isQuote />
  </div>
);

export { QuoteContent };
